import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Envelope, ArrowLeft, CheckCircle } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { identifier: identifier.trim() });
      setDone(data.mode || "unknown");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen app-bg flex justify-center">
      <div className="w-full md:max-w-md min-h-screen flex flex-col px-6 py-10">
        <Link to="/login" className="flex items-center gap-1 text-stone-500 text-sm font-semibold" data-testid="forgot-back-link">
          <ArrowLeft size={18} weight="bold" /> Kembali
        </Link>

        <div className="flex flex-col items-center mt-8 mb-8">
          <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-lg">
            <Envelope size={30} weight="fill" className="text-secondary" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-stone-800 mt-4">Lupa Password</h1>
          <p className="text-stone-500 text-sm text-center mt-1 px-4">Masukkan email atau nomor HP akun Anda</p>
        </div>

        {done ? (
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
            className="bg-white border border-stone-200 rounded-2xl p-5 text-center" data-testid="forgot-success">
            <CheckCircle size={44} weight="fill" className="text-primary mx-auto mb-3" />
            {done === "email" ? (
              <p className="text-stone-600 text-sm leading-relaxed">Tautan atur ulang kata sandi telah dikirim ke email admin. Silakan cek kotak masuk Anda.</p>
            ) : (
              <p className="text-stone-600 text-sm leading-relaxed">Permintaan reset password Anda telah dikirim ke admin sekolah. Admin akan segera mengatur ulang kata sandi Anda. Silakan hubungi pihak sekolah untuk info lebih lanjut.</p>
            )}
            <Link to="/login" className="inline-block mt-5 text-primary font-semibold text-sm" data-testid="forgot-tologin-link">Kembali ke Masuk</Link>
          </motion.div>
        ) : (
          <motion.form initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Envelope size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
              <input data-testid="forgot-identifier-input" type="text" required value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                placeholder="Email atau No. HP"
                className="w-full bg-white border border-stone-200 rounded-2xl py-4 pl-12 pr-4 outline-none focus:border-primary transition-colors" />
            </div>
            <button data-testid="forgot-submit-btn" disabled={loading}
              className="w-full bg-primary text-white font-heading font-semibold text-lg py-4 rounded-full shadow-lg shadow-primary/20 active:scale-95 transition-transform disabled:opacity-60">
              {loading ? "Memproses..." : "Kirim Permintaan"}
            </button>
          </motion.form>
        )}
      </div>
    </div>
  );
}
